import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function CycleCard() {
  const { user, updateProfile } = useAuth();
  const save = async (patch) => { try { await updateProfile(patch); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <section className="card p-5 space-y-4" data-testid="cycle-card">
      <div className="flex items-center justify-between">
        <div><div className="font-medium">Cycle tracking</div><div className="text-xs text-stone-600">Lighter days when you need them, phase lines on your trends</div></div>
        <Switch className="tap" data-testid="me-cycle-switch" checked={user.cycle_tracking} onCheckedChange={(v) => save({ cycle_tracking: v })} />
      </div>
      {user.cycle_tracking && (
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs text-stone-600">Last period start
            <input type="date" data-testid="me-period-date" defaultValue={user.last_period_start || ""} onBlur={(e) => e.target.value && save({ last_period_start: e.target.value })}
              className="mt-1 w-full h-10 px-3 rounded-lg border border-stone-200 text-sm" /></label>
          <label className="text-xs text-stone-600">Cycle length
            <input type="number" min={20} max={45} data-testid="me-cycle-length" defaultValue={user.cycle_length} onBlur={(e) => save({ cycle_length: Number(e.target.value) })}
              className="mt-1 w-full h-10 px-3 rounded-lg border border-stone-200 text-sm" /></label>
        </div>
      )}
    </section>
  );
}
